import * as types from "./mutation-types";

export default {
  [types.SET_MOEDAS](state, payload) {
    state.moedas = payload;
  },
  [types.SET_MOEDA](state, payload) {
    state.moeda = payload;
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  }
};
